/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_New_Marker_TitleInputs */

const en_markers_new_marker_title = /** @type {(inputs: Markers_New_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Marker`)
};

const fr_markers_new_marker_title = /** @type {(inputs: Markers_New_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau marqueur`)
};

const de_markers_new_marker_title = /** @type {(inputs: Markers_New_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Marker`)
};

const it_markers_new_marker_title = /** @type {(inputs: Markers_New_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo marcatore`)
};

const ru_markers_new_marker_title = /** @type {(inputs: Markers_New_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый маркер`)
};

const es_markers_new_marker_title = /** @type {(inputs: Markers_New_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo marcador`)
};

const zh_cn2_markers_new_marker_title = /** @type {(inputs: Markers_New_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新标记`)
};

const ja_markers_new_marker_title = /** @type {(inputs: Markers_New_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいマーカー`)
};

const hi_markers_new_marker_title = /** @type {(inputs: Markers_New_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया मार्कर`)
};

const pt_pt2_markers_new_marker_title = /** @type {(inputs: Markers_New_Marker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo marcador`)
};

/**
* | output |
* | --- |
* | "New Marker" |
*
* @param {Markers_New_Marker_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_new_marker_title = /** @type {((inputs?: Markers_New_Marker_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_New_Marker_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_new_marker_title(inputs)
	if (locale === "de") return de_markers_new_marker_title(inputs)
	if (locale === "it") return it_markers_new_marker_title(inputs)
	if (locale === "ru") return ru_markers_new_marker_title(inputs)
	if (locale === "es") return es_markers_new_marker_title(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_new_marker_title(inputs)
	if (locale === "ja") return ja_markers_new_marker_title(inputs)
	if (locale === "hi") return hi_markers_new_marker_title(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_new_marker_title(inputs)
	return en_markers_new_marker_title(inputs)
});